import React from 'react';

export default function PageTitle(props) {
    return (
        <title className="PageTitle">{props.children}</title>
    );

}


